import { ArrowRight, Award, Crown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import PublicShell from '@/components/layouts/PublicShell';

const AdvisoryVermoegenPage = () => {
  return (
    <PublicShell>
          {/* Hero Section - Exact Height */}
          <div className="relative" style={{height: '70vh'}}>
            <div 
              className="absolute inset-0 bg-cover bg-center"
              style={{backgroundImage: 'url(/images/sv-skyline-evening.jpg)'}}
            ></div>
            <div className="absolute inset-0 bg-gradient-to-r from-slate-900/75 via-slate-800/60 to-transparent"></div>
            
            <div className="relative z-10 h-full flex items-center px-16">
              <div className="max-w-3xl">
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-light text-white mb-8 leading-tight font-serif">
              Advisory für Vermögensverwaltungen & Family Offices
            </h1>
                
                <p className="text-xl md:text-2xl text-slate-200 leading-relaxed mb-10 max-w-3xl">
                  Strategische Begleitung auf höchstem Niveau für institutionelle Anleger
                </p>
                
          </div>
        </div>
      </div>

          {/* Green Section */}
          <div className="bg-primary-800">
            <div className="grid grid-cols-1 lg:grid-cols-5">
              {/* Left Side - Text (3 columns) */}
              <div className="lg:col-span-3 p-12 lg:p-20 flex items-center">
                <div className="max-w-2xl">
                  <div className="w-16 h-16 mb-8">
                    <Crown className="w-16 h-16 text-white" />
                  </div>
                  
                  <h2 className="text-4xl md:text-5xl font-light text-white mb-8 leading-tight font-serif">
                    Unsere <em className="italic">Advisory-Services</em>
                  </h2>
                  
                  <p className="text-xl text-primary-100 leading-relaxed">
                    Maßgeschneiderte Beratung für Vermögensverwaltungen, Family Offices und institutionelle Investoren. 
                    Strategische Begleitung auf höchstem Niveau.
                  </p>
                </div>
              </div>

              {/* Right Side - Image (2 columns) */}
              <div className="lg:col-span-2 relative min-h-96">
                <div 
                  className="absolute inset-0 bg-cover bg-center"
                  style={{backgroundImage: 'url(/images/sv-skyline-financial.jpg)'}}
                ></div>
              </div>
            </div>
          </div>

          {/* Three White Cards Section - Services */}
          <div className="relative -mt-16 z-20">
            <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24">
              {/* Single Large White Box */}
              <div className="bg-white rounded-none shadow-[0_8px_40px_rgba(16,24,40,0.08)] w-full mb-12">
                <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-200">
                  {/* Card 1 - Strategische Beratung */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Strategische Beratung</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed mb-4">
                      Entwicklung von Anlagestrategien und Portfoliostrukturen für komplexe Vermögensstrukturen.
                    </p>
                    <div className="text-[14px] text-slate-600 space-y-1">
                      <div>• Asset Allocation Strategien</div>
                      <div>• Multi-Asset Portfolio Design</div>
                      <div>• Alternative Investments</div>
                      <div>• ESG Integration</div>
                    </div>
                        </div>

                  {/* Card 2 - Risikomanagement */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Risikomanagement</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed mb-4">
                      Umfassendes Risikomanagement und Compliance-Beratung für institutionelle Portfolios.
                    </p>
                    <div className="text-[14px] text-slate-600 space-y-1">
                      <div>• Risk Assessment & Monitoring</div>
                      <div>• Stresstesting & Szenarioanalyse</div>
                      <div>• Regulatory Compliance</div>
                      <div>• Liquiditätsmanagement</div>
                        </div>
                      </div>

                  {/* Card 3 - Performance Analytics */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Performance Analytics</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed mb-4">
                      Detaillierte Performance-Analyse und Benchmarking für optimale Anlageergebnisse.
                    </p>
                    <div className="text-[14px] text-slate-600 space-y-1">
                      <div>• Performance Attribution</div>
                      <div>• Benchmarking & Peer Analysis</div>
                      <div>• Manager Selection & Due Diligence</div>
                      <div>• Reporting & Communication</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Purple Section - Target Clients */}
          <div className="bg-primary-900 py-20">
            <div className="grid grid-cols-1 lg:grid-cols-5">
              {/* Left Side - Text (3 columns) */}
              <div className="lg:col-span-3 p-12 lg:p-20 flex items-center">
                <div className="max-w-2xl">
                  <div className="w-16 h-16 mb-8">
                    <Award className="w-16 h-16 text-white" />
                  </div>
                  
                  <h2 className="text-4xl md:text-5xl font-light text-gold-400 mb-8 leading-tight font-serif">
                    Unsere <em className="italic">Zielgruppen</em>
                  </h2>
                  
                  <p className="text-xl text-primary-100 leading-relaxed">
                    Family Offices, Vermögensverwaltungen und institutionelle Investoren - 
                    wir bieten maßgeschneiderte Lösungen für komplexe Anlagestrukturen.
                  </p>
                </div>
              </div>

              {/* Right Side - Image (2 columns) */}
              <div className="lg:col-span-2 relative min-h-96">
                <div 
                  className="absolute inset-0 bg-cover bg-center"
                  style={{backgroundImage: 'url(/images/sv-office-building.jpg)'}}
                ></div>
              </div>
            </div>
          </div>

          {/* Three White Cards Section - Target Groups */}
          <div className="relative -mt-16 z-20">
            <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24">
              {/* Single Large White Box */}
              <div className="bg-white rounded-none shadow-[0_8px_40px_rgba(16,24,40,0.08)] w-full mb-12">
                <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-200">
                  {/* Card 1 - Family Offices */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Family Offices</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed">
                      Betreuung von Unternehmerfamilien und vermögenden Privatpersonen mit komplexen Anlagestrukturen. 
                      Individuelle Strategieentwicklung und kontinuierliche Betreuung auf höchstem Niveau.
                    </p>
                    </div>

                  {/* Card 2 - Vermögensverwaltungen */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Vermögensverwaltungen</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed">
                      Unterstützung von unabhängigen Vermögensverwaltern bei Portfoliokonstruktion und Risikomanagement. 
                      Langjährige Erfahrung und internationale Expertise für optimale Ergebnisse.
                    </p>
                  </div>

                  {/* Card 3 - Institutionelle Investoren */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Institutionelle Investoren</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed">
                      Beratung von Pensionsfonds, Stiftungen und anderen institutionellen Anlegern. 
                      Maßgeschneiderte Lösungen und flexible Umsetzung für jeden Mandanten.
                    </p>
              </div>
            </div>
          </div>
        </div>
      </div>

          {/* CTA Section - Purple */}
          <div className="bg-primary-800 py-16">
            <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 text-center">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                  Exzellente Beratung auf höchstem Niveau
                </h2>
                <p className="text-xl text-primary-100 mb-8 leading-relaxed">
                  Profitieren Sie von unserer langjährigen Expertise und unserem tiefen Verständnis 
                  für komplexe Anlagestrukturen.
                </p>
              <Link to="/contact">
                  <Button className="bg-white text-primary-800 hover:bg-gray-100 px-8 py-4 text-lg font-medium rounded-none">
                    Exklusives Beratungsgespräch vereinbaren
                    <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
    </PublicShell>
  );
};

export default AdvisoryVermoegenPage;
